import React from 'react';
import ReactDOM from 'react-dom';

import ContactForm from './components/ContactForm.js';
import EBook from './components/EBook.js';

import Animation from './js/animations.js';

import './js/oembed.js';
import './js/swiperSliders';

document.addEventListener("DOMContentLoaded", function () {
    let doc = document;
    let contactForm = doc.querySelectorAll('#form');
    let eBookElement = doc.querySelector('#ebook');

    if (eBookElement) {
        ReactDOM.render(<EBook
            type={eBookElement.getAttribute('data-type')}
            content={eBookElement.getAttribute('data-content')}
        />, eBookElement);
    }

    if (contactForm.length > 0) {
        contactForm.forEach((item) => {
            ReactDOM.render(<ContactForm
                formType={item.getAttribute('data-type')}
                service={item.getAttribute('data-service')}
                allServices={
                    JSON.parse(item.getAttribute('data-services'))
                }
            />, item);
        })
    }

    let buttonsMore = doc.querySelectorAll('.blue-boxes .row .item button');
    if (buttonsMore.length > 0) {
        buttonsMore.forEach((item) => {
            const prevText = item.textContent;
            item.addEventListener('click', () => {
                item.parentElement.classList.toggle('open');

                if (item.parentElement.classList.contains('open')) {
                    item.textContent = "Menej";
                } else {
                    item.textContent = prevText;
                }
            });
        })
    }

    let sliderContainer = doc.querySelector('.slider-container');
    let width = doc.documentElement.clientWidth;

    if (sliderContainer) {
        let refALeft = doc.querySelector('.references .arrow-left');
        let refARight = doc.querySelector('.references .arrow-right');
        let slideItems = sliderContainer.querySelectorAll('.slide:not(.hide)');

        slideItems.forEach((item) => {
            item.style.flex = '0 0 ' + width + 'px';
            item.style.maxWidth = width + 'px';
        });

        let counter = 1;
        refALeft.addEventListener('click', () => {
            let slideItems = sliderContainer.querySelectorAll('.slide:not(.hide)');

            if (counter !== 1) {
                let actMargin = parseInt(sliderContainer.style.marginLeft, 10) || 0;
                sliderContainer.style.marginLeft = actMargin + width + 'px';

                counter--;
            } else {
                sliderContainer.style.marginLeft = width * (slideItems.length - 1) * -1 + 'px';
                counter = slideItems.length;
            }
        });
        refARight.addEventListener('click', () => {
            let slideItems = sliderContainer.querySelectorAll('.slide:not(.hide)');
            if (slideItems.length > counter) {
                let actMargin = parseInt(sliderContainer.style.marginLeft, 10) || 0;
                sliderContainer.style.marginLeft = actMargin - width + 'px';

                counter++;
            } else {
                sliderContainer.style.marginLeft = '0px';
                counter = 1;
            }
        });

        let radios = doc.querySelectorAll('input[type=radio][name="select-references"]');
        radios.forEach((item) => {
            item.addEventListener('change', () => {
                slideItems.forEach((slideItem) => {
                    slideItem.classList.remove('hide');
                    if (slideItem.getAttribute('data-slide-category') !== item.value && item.value !== 'all') {
                        slideItem.classList.add('hide');
                    }
                });
                sliderContainer.style.marginLeft = '0px';
                counter = 1;

            })
        });

        window.addEventListener("resize", function () {
            width = doc.documentElement.clientWidth;

            slideItems.forEach((item) => {
                item.style.flex = '0 0 ' + width + 'px';
                item.style.maxWidth = width + 'px';
            });

            sliderContainer.style.marginLeft = width * (counter - 1) * -1 + 'px';

        });
    }

    let certificatesContainer = doc.querySelector('.list-of-certificates .items');
    let certificates = doc.querySelectorAll('.list-of-certificates .item');

    if (certificates.length > 0) {
        let refALeft = doc.querySelector('.list-of-certificates .arrow-left');
        let refARight = doc.querySelector('.list-of-certificates .arrow-right');
        let widthItem = certificates[0].clientWidth;
        certificates.forEach((item) => {
            item.style.flex = '0 0 ' + widthItem + 'px';
            item.style.maxWidth = widthItem + 'px';
        });
        let countView = 5;
        if (window.innerWidth < 992) {
            countView = 3;
        }
        if (window.innerWidth < 768) {
            countView = 2;
        }
        if (window.innerWidth < 501) {
            countView = 1;
        }
        let counter = 1;
        refALeft.addEventListener('click', () => {
            if (counter !== 1) {
                let actMargin = parseInt(certificatesContainer.style.marginLeft, 10) || 0;
                certificatesContainer.style.marginLeft = actMargin + widthItem + 'px';

                counter--;
            } else {
                certificatesContainer.style.marginLeft = widthItem * (certificates.length - countView) * -1 + 'px';
                counter = certificates.length - (countView - 1);
            }
        });
        refARight.addEventListener('click', () => {
            if (certificates.length - (countView - 1) > counter) {
                let actMargin = parseInt(certificatesContainer.style.marginLeft, 10) || 0;
                certificatesContainer.style.marginLeft = actMargin - widthItem + 'px';

                counter++;
            } else {
                certificatesContainer.style.marginLeft = '0px';
                counter = 1;
            }
        });


    }

    let contactFormModal = doc.querySelector('.modal-contact-form');
    if (contactFormModal) {
        let contactFormButton = doc.querySelectorAll('a.open-contact-form,button.open-contact-form');
        let body = doc.querySelector('body');
        let html = doc.querySelector('html');

        const closeContactForm = contactFormModal.querySelector('.close');
        closeContactForm.addEventListener('click', () => {
            body.classList.remove('open-contact-form');
            html.removeAttribute('style');
        });

        if (contactFormButton[0]) {
            contactFormButton.forEach((button) => {
                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    body.classList.add('open-contact-form');
                    html.style.overflow = 'hidden';
                });
            })
        }
    }

    let newsDots = doc.querySelectorAll('.news .dots button');
    let newsContainer = doc.querySelector('.news .blog-items');
    if (newsContainer) {
        newsDots.forEach((item, index) => {
            item.addEventListener('click', () => {
                doc.querySelector('.news .dots button.active').classList.remove('active');
                item.classList.add('active');
                newsContainer.style.left = 100 * index * -1 + 'vw';
            })
        });
    }


    let headerItems = doc.querySelectorAll('header .menu nav > ul > li > a');
    headerItems.forEach((item) => {
        if (item.parentElement.classList.contains('has-submenu')) {
            item.addEventListener('click', (e) => {
                item.parentElement.classList.toggle('open');
                e.preventDefault();
            })
        }
    })


    let hamburger = doc.querySelector('.hamburger');
    if (hamburger) {
        hamburger.addEventListener('click', () => {
            doc.querySelector('body').classList.toggle('open-menu');
        })
    }
});

document.addEventListener("DOMContentLoaded", () => {
    const textContainers = document.querySelectorAll(".blue-boxes .item");

    textContainers.forEach(container => {
        const textContent = container.querySelector("p");
        const showMoreButton = container.querySelector("button");

        const isOverflowing = textContent.scrollHeight > textContent.offsetHeight;

        if (isOverflowing) {
            showMoreButton.style.display = 'inline-block'; // Show the button if overflowing
        }

        showMoreButton.addEventListener('click', () => {
            toggleText(showMoreButton, textContent);
        })
    });
});

function toggleText(button, content) {
    content.classList.toggle('expanded');
    button.textContent = content.classList.contains('expanded') ? 'Zobraziť menej' : 'Zobraziť viac';
}

